// Relationship fact types (cfg.relationship_fact_types) as delivered in
// globalConfigs.relationship_fact_types: the catalogue behind
// public.relationship_facts. is_personal rows are in-app only (the Facts
// section shows a lock; they never reach a draft, brief or report);
// visible_in_drafts rows may be cited by agent drafts.
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const RelationshipFactTypeModelSchema = z
  .object({
    id: z.string(),
    type_key: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    guidance: z.string().nullish(),
    is_personal: z.boolean(),
    visible_in_drafts: z.boolean(),
    sort_order: z.number()
  })
  .strict()

export const RelationshipFactTypeModelFields = makeFieldKeys(RelationshipFactTypeModelSchema)

export type RelationshipFactTypeModel = z.infer<typeof RelationshipFactTypeModelSchema>
